/**
 * Repeatedly parse JSON strings until they return a object (or anything which isn't a string).
 * This solves an issue where the API may return data which has been double-stringified 😔
 */
export function deepJSONParse<T = unknown>(
  input: string | Array<string | number> | Dictionary<string | number>
): T {
  if (typeof input !== "string") {
    return input as T;
  }

  try {
    const parsed = JSON.parse(input);
    return deepJSONParse<T>(parsed);
  } catch {
    return input as T;
  }
}
